import { downloadBlobAsFile } from './downloadFile';

interface Navigator {
  msSaveBlob?: (blob: Blob, defaultName?: string) => boolean;
}

// Creates a CSV of a set of objects and triggers download.
export const generateCsv = async (rows: any[], keys: string[], filename: string) => {
  const separator: string = ',';
  const csvContent = `${keys.join(separator)}\n${rows
    .map((row) =>
      keys
        .map((k) => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];

          cell = cell instanceof Date ? cell.toLocaleString() : cell.toString().replace(/"/g, '""');

          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        })
        .join(separator)
    )
    .join('\n')}`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  if ((navigator as unknown as Navigator).msSaveBlob) {
    (navigator as unknown as Navigator).msSaveBlob(blob, filename);
  } else {
    downloadBlobAsFile(blob, filename);
  }
};
